@if (inputControl) {
    <input
        type="text"
        class="font-sans w-full h-full text-base font-light tracking-wide text-dat-grey-500 focus-visible:outline-none"
        [name]="randomName"
        [attr.data-testid]="id()"
        [attr.data-uiType]="'textBox'"
        [attr.data-styleTarget]="id() + '-input'"
        [attr.data-styleDisabled]="disabled()"
        currencyMask
        [options]="currencyOptions()"
        [id]="id()"
        [placeholder]="placeholder()"
        [formControl]="inputControl"
        (keyup)="keyUp($event)"
    />
}
